import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../../../stateManager/store";
import { getComponents, onDrop } from "../../helpers";
import { Listbox, Transition, Tab, Disclosure } from "@headlessui/react";
import { pushFormActionStack, removeElement, undoDeleteElement, updateElement, updateElementOnUndoRedo, updateTab, updateTabId, updateModalContent } from "../../../../../../stateManager/store/formCreation_v2/actions";
import { ReactComponent as Down } from "../../../../../../assets/svg/solobuilder/dropdown-down.svg";
import { ReactComponent as Up } from "../../../../../../assets/svg/solobuilder/dropdown-up.svg";
import { ReactComponent as Delete } from "../../../../../../assets/svg/solobuilder/expansion-delete.svg";
import { saveSelectedElements } from "../../../../../../stateManager/store/segmentControl/actions";
import { getFunctions } from "../../../../Solo/forms/create/properties/commonFunctions";
import { useParams } from "react-router-dom";
import { guessTextColor } from "../../helpers/guessTextColor";
import SegmentsExpansionPanel from "./segmentExpansion";
import { onsetClrPicContext } from "../../../../../../stateManager/store/common/action";
import update from "immutability-helper";
import { ReactComponent as Code } from "../../../../../../assets/svg/solobuilder/code.svg";
import { EditorPanel } from "../EditorPanel";
import { useDebouncedAction } from "../../../../../../helpers/commonFunction";
import { myRedoStack, myUndoStack } from "../../stack/Stack";
import { UNDO, REDO, FormCreationData } from "../../../../../../stateManager/store/formCreation_v2/types";
import EditorIcon from "../../../../../../assets/svg/editorIcon.svg";
import { TextArea } from "../TextArea";
import { Wrapper } from "../Panel";
import { initialState } from "../../helpers/segmentHelpers";
import WizardStepsExtensionPanel from "./wizardStepsExpansion";
import { ColorPicker } from "../ColorPicker";
import { ModalExpansionPanel } from "./modalExpansion";
import CustomAutoComplete from "../../../../Assisted/forms/create/properties/customAutoComplete";
import I18AutoCompletion from "../../../../Assisted/forms/create/properties/I18NAutoComplete";
export const AddExpansion = ((props: any) => {
    const { config, setColorPickerContext, timeLineFields, setTimeLineFields, isCheckedIn } = props;
    const [showError, setShowError] = useState(false)
    const { selectedElementId, deviceType, canvasConfig, componentOrder } = useSelector((state: AppState) => state.formJson);
    const { components } = getComponents();
    const state = useSelector((state: AppState) => state)
    const component = components[selectedElementId] || {};
    const { type = "" } = component;
    const propsSegments = components[selectedElementId]?.properties?.config?.segments
    const cellConditions = components[selectedElementId]?.properties?.config?.cellConditions
    const timeLineValues = components[selectedElementId]?.properties?.config?.section
    const propsWizardSteps = components[selectedElementId]?.properties?.config?.wizardSteps
    const properties = component?.properties?.config
    const [tabAddMode, setTabAddMode] = useState<boolean>(false)
    const [ErrMessage, setErrMessage] = useState("");
    const [tabData, setTabData] = useState<any>({})
    const dispatch = useDispatch();
    const [editorContext, setEditorContext] = useState({
        visibility: false,
        source: "",
        where: "",
    })
    const [conditionFields, setConditionFields] = useState<any>({
        "col_id": "",
        "expression": null,
        "background": "",
        "color": ""
    })
    const { savedTemplate } = useSelector((state: any) => state)
    const [functionsdef, setFunctionsdef] = useState<any>();
    const params: any = useParams();
    const version = useSelector((state: any) => state.apps.appVersion[params["appId"]]);
    const [conditions, setConditions] = useState<any>([])
    const [distinctId, setdistinctId] = useState<any>(null);
    const [distinctTitle, setdistinctTitle] = useState<any>(null);
    const [segmentFields, setSegmentFields] = useState<any>({
        id: "",
        label: "",
        visible: true,
        disable: false,
        selectedIconUrl: "",
        unSelectedIconUrl: ""
    })
    const [segmentLabel, setSegmentLabel] = useState<any>(null);
    const [timeLines, setTimeLines] = useState<any>([])
    const [wizardTitle, setWizardTitle] = useState<any>(null);
    const [wizardDescription, setWizardDescription] = useState<any>(null);
    const [wizardSteps, setWizardSteps] = useState<any>({
        id: "",
        title: "",
        description: ""
    })
    const addTab = (() => {
        let { key = "" } = tabData;
        if (key) {
            let data: any = {
                type: "Component",
                json: {
                    type: 'Tab',
                    label: key,
                }
            }
            onDrop({ id: component?.id }, data, deviceType)
            setTabAddMode(false)
            setErrMessage("")
        } else {
            setErrMessage("Label should not empty!")
        }

    })

    const handleChangeTab = (id: string, field: string, value: string) => {
        dispatch(
            updateTab({
                id: id,
                field,
                value,
            })
        );
    }

    const handleChangeWizard = (id: string, field: string, value: string) => {
        dispatch(
            updateTab({
                id: id,
                field,
                value,
            })
        );
    }

    const handleChange = (path: any, value: any) => {
        dispatch(
            updateElement({
                id: selectedElementId,
                path,
                value,
            })
        );
    }

    useEffect(() => {
        let uniqueId = propsSegments && propsSegments?.filter((item: any) => item?.segmentFields?.id === segmentFields?.id) || []
        if (uniqueId.length > 0) {
            setdistinctId(false)
        } else {
            setdistinctId(true)
        }
    }, [segmentFields])

    useEffect(() => {
        let uniqueTitle = propsWizardSteps && propsWizardSteps?.filter((item: any) => item?.title === wizardTitle) || []
        if (uniqueTitle.length > 0) {
            setdistinctTitle(false)
        } else {
            setdistinctTitle(true)
        }
    }, [wizardTitle])

    const addSegments = () => {
        if (distinctId) {
            if (((properties.segmentType === "text" ||
                properties.segmentType === "textWithIcon") ?
                (segmentFields.id !== "" && segmentFields.label !== "" && segmentLabel) :
                (segmentFields.id !== "" && segmentLabel))
            ) {
                setErrMessage("")
                let seg = {
                    id: Math.random().toString(36).substring(6),
                    key: `segment_${(propsSegments && propsSegments?.length || 0) + 1}`,
                    segmentLabel: segmentLabel,
                    segmentFields,
                }
                myUndoStack.push({
                    id: selectedElementId,
                    fields: [],
                    label: "",
                    properties: {},
                    type: "",
                    value: seg
                });
                myRedoStack.clear();
                dispatch(pushFormActionStack({
                    undo: () => {
                        const poppedElement = myUndoStack.pop();
                        const lastSegment = poppedElement?.value;
                        if (poppedElement) {
                            myRedoStack.push({ ...poppedElement, id: selectedElementId, value: seg })
                            let temp = properties?.segments?.filter((val: any) => {
                                return val.id !== lastSegment.id
                            })
                            handleChange("properties.config.segments", temp)
                            dispatch({
                                type: UNDO,
                                actionPointer: state.actionPointer - 1,
                            })
                        }
                    },
                    redo: () => {
                        const poppedElement = myRedoStack.pop();
                        if (poppedElement) {
                            myUndoStack.push({ ...poppedElement })
                            let data = propsSegments
                            if (poppedElement.value) {
                                handleChange("properties.config.segments", data)
                            }
                            dispatch({
                                type: REDO,
                                actionPointer: state.actionPointer + 1,
                            })
                        }
                    }
                }))
                let data = propsSegments
                if (seg) {
                    data.push(seg)
                    handleChange("properties.config.segments", data)
                }
                setTabAddMode(false)
                setSegmentLabel(null)
                setSegmentFields({
                    ...segmentFields,
                    id: "",
                    label: "",
                    visible: true,
                    disable: false,
                    selectedIconUrl: "",
                    unSelectedIconUrl: ""
                })
                setdistinctId(null)
            } else {
                if ((properties.segmentType === "text" ||
                    properties.segmentType === "textWithIcon")) {
                    setErrMessage("Segment label, Id, name should not be empty")
                } else {
                    setErrMessage("Segment label, Id should not be empty")
                }
            }
        } else {
            setErrMessage("Segment Id is already exist")
        }
    }

    const { segmentSelectedElementsIds } = useSelector((state: any) => state?.saveLoadedSegmentId)
    useEffect(() => {
        if (selectedElementId && (segmentSelectedElementsIds.includes(selectedElementId) === false)) {
            dispatch(saveSelectedElements(selectedElementId))
            handleChange("properties.config.segments", initialState)
        }
    }, [selectedElementId])

    const addCondition = () => {
        let con = {
            key: `condition_${cellConditions && cellConditions?.length + 1}`,
            conditionFields
        }
        setConditions((prev: any) => ([...prev, con]))
        setTabAddMode(false)
        setConditionFields({
            ...conditionFields,
            "col_id": "",
            "expression": null,
            "background": "",
            "color": ""
        })
    }

    const addTimeLineFields = () => {
        let con = {
            key: `condition_${timeLineValues?.length + 1}`,
            timeLineFields
        }
        setTimeLines((prev: any) => ([...prev, con]))
        setTabAddMode(false)
        setTimeLineFields({
            label: "",
            title: {},
            subTitle: {},
            desc: '',
        })
    }

    useEffect(() => {
        if (timeLineValues) {
            setTimeLineFields(timeLineValues)
        }
    }, [timeLineValues])

    useEffect(() => {
        setConditionFields({
            ...conditionFields,
            background: savedTemplate?.condition_background || "",
            color: savedTemplate?.condition_color || ""
        })
    }, [savedTemplate?.condition_background, savedTemplate?.condition_color])

    useEffect(() => {
        setConditionFields({
            ...conditionFields,
            background: savedTemplate?.condition_background || "",
            color: savedTemplate?.condition_color || ""
        })
    }, [savedTemplate?.condition_background, savedTemplate?.condition_color])

    useEffect(() => {
        if (conditions) {
            handleChange("properties.config.cellConditions", conditions)
        }
    }, [conditions])

    useEffect(() => {
        if (timeLines) {
            handleChange("properties.config.section", timeLines)
        }
    }, [timeLines])

    useEffect(() => {
        if (timeLineValues && timeLineValues.length > 0) {
            setTimeLines(timeLineValues)
        }
    }, [])

    useEffect(() => {
        if (cellConditions && cellConditions.length > 0) {
            setConditions(cellConditions)
        }
    }, [])

    const removeSelectedElement = (e: React.MouseEvent<HTMLElement>, id: string) => {
        e.stopPropagation();
        if (component.fields.length > 1) {
            dispatch(
                removeElement({
                    id,
                    parentId: components[id]?.parentId,
                    type,
                })
            );
        }
    };
    const removeCondition = (e: React.MouseEvent<HTMLElement>, removeItem: any) => {
        setShowError(false)
        e.stopPropagation();
        let temp = conditions.filter((val: any) => {
            return val.key !== removeItem.key
        })
        setConditions(temp);
    }

    const removeSegment = (e: React.MouseEvent<HTMLElement>, removeItem: any) => {
        e.stopPropagation();
        myUndoStack.push({
            id: selectedElementId,
            fields: [],
            label: "",
            properties: {},
            type: "",
            value: removeItem
        });
        myRedoStack.clear();
        let temp = properties?.segments?.filter((val: any) => {
            return val.id !== removeItem.id
        })
        handleChange("properties.config.segments", temp)
        dispatch(pushFormActionStack({
            undo: () => {
                const poppedElement = myUndoStack.pop();
                const lastSegment = poppedElement?.value;
                if (poppedElement) {
                    myRedoStack.push({ ...poppedElement, id: selectedElementId, value: lastSegment })
                    let data = propsSegments
                    if (poppedElement.value) {
                        handleChange("properties.config.segments", data)
                    }
                    dispatch({
                        type: UNDO,
                        actionPointer: state.actionPointer - 1,
                    })
                }
            },
            redo: () => {
                const poppedElement = myRedoStack.pop();
                if (poppedElement) {
                    myUndoStack.push({ ...poppedElement })
                    let temp = properties?.segments.filter((val: any) => {
                        return val.id !== poppedElement?.value?.id
                    })
                    dispatch({
                        type: REDO,
                        actionPointer: state.actionPointer + 1,
                    })
                    if (temp) {
                        handleChange("properties.config.segments", temp)
                    }
                }
            }
        }))

    }

    const removeTimeLineFields = (e: React.MouseEvent<HTMLElement>, removeItem: any) => {
        e.stopPropagation();
        let temp = timeLineValues.filter((val: any) => {
            return val.key !== removeItem.key
        })
        setTimeLines(temp);
    }

    const openCodeEditorModal = async () => {
        let data = await getFunctions(params["appId"], version.versionId);
        setFunctionsdef(data);
    }

    const resetAllStates = () => {
        setSegmentLabel(null);
        setSegmentFields({
            id: "",
            label: "",
            visible: true,
            disable: false,
            selectedIconUrl: "",
            unSelectedIconUrl: ""
        });
        setTabAddMode(false);
        setErrMessage("");
        setdistinctId(null)
    }

    function getNestedComponents(fields: string[], array: FormCreationData[] = []) {
        fields.forEach((fieldId: string) => {
          const component = components[fieldId];
          array.push(component);
          // recursively all fields
          if (component?.fields?.length) {
            getNestedComponents(component.fields, array);
          }
        })
      }

    const removeWizardSteps = (e: React.MouseEvent<HTMLElement>, id: string, selectedElementId: string) => {
        e.stopPropagation();
        const childrenArray: FormCreationData[] = [];
        getNestedComponents(component?.fields, childrenArray);
        if (component.fields.length > 1) {
            const component = components[id];
            if (component && Object.keys(component)) {
                const payload: FormCreationData = {
                ...component,
                id: id,
                parentId: components[id].parentId || "",
                type: components[id].type,
                children: childrenArray,
                }
                // remove the child reference from parent node
                if (components[id].parentId) {
                const parentId: any = components[id].parentId;
                payload.metadata = {
                    position: components[parentId].fields.indexOf(components[id].id)
                }
                }
                console.log(payload, 'payload details')
                // Undo Redo for delete elements
                myUndoStack.push({ ...payload });
                // component order
                myUndoStack.saveOrder(componentOrder);
                const order = myUndoStack.getOrder();

                dispatch(pushFormActionStack({
                undo: () => {
                    const poppedElement = myUndoStack.pop();
                    if (poppedElement) {
                    myRedoStack.push(poppedElement);
                    console.log(poppedElement, 'poppedElement')
                    dispatch(
                        undoDeleteElement(poppedElement, order),
                    )
                    }
                },
                redo: () => {
                    const poppedElement = myRedoStack.pop();
                    if (poppedElement) {
                    myUndoStack.push({ ...poppedElement });
                    dispatch(removeElement({
                        id: poppedElement.id,
                        parentId: poppedElement.parentId || "",
                        type: poppedElement.type,
                        increment: 1
                    }))
                    }
                }
                }));

                dispatch(removeElement({
                    id,
                    parentId: components[id].parentId,
                    type,
                    selectedElementId
                }))
            }
        }
    }

    const addWizardSteps = () => {
        if (distinctTitle) {
            if (wizardTitle !== "" && wizardTitle !== null) {
                let data: any = {
                    type: "Component",
                    json: {
                        id: Math.random().toString(36).substring(6),
                        title: wizardTitle,
                        description: wizardDescription,
                        type: "FormWizardStep",
                        label: `Form Wizard Step ${wizardTitle}`
                    }
                }
                onDrop({ id: component?.id }, data, deviceType)
                setErrMessage("")
                setTabAddMode(false)
                setWizardTitle(null)
                setWizardDescription(null)
                setdistinctTitle(null)
            } else {
                setErrMessage("Wizard steps title should not be empty")
            }
        } else {
            setErrMessage("Wizard steps title is already exist")
        }
    }

    interface IModalConfig {
        type: 'Text' | 'Icon' | 'Input' | 'Image' | ""
        Text?: { content: string; styles: any };
        Icon?: { variant: string; styles: any };
        Input?: { name: string; styles: any };
        Image?: { url: string; styles: any };
    }

    const [modalConfigs, setModalConfigs] = useState<IModalConfig>({
        type: '',
        [type] : {},
    });

    const addModalContent = (() => {
        const { type } = modalConfigs;
            if (
                (type === "Text" && modalConfigs?.Text?.content) ||
                (type === "Icon" && modalConfigs?.Icon?.variant) ||
                (type === "Input" && modalConfigs?.Input?.name) ||
                (type === "Image" && modalConfigs?.Image?.url)
            ) {
            handleAdd();
            setErrMessage("");
            setTabAddMode(false);
        } else {
            setErrMessage("Select a content type and provide relevant details")
        }
    })

    const addContent = (content: any) => {
        dispatch(
          updateModalContent({
            type: "SET",
            content
          })
        );
      };

    const handleAdd = () => {
        addContent({
            id: Math.random().toString(36).substring(6),
            ...modalConfigs
        });
        reset();
    };

    const onModalChange = (type: "type" | "config" | "styles", name: string, value: any) => {
        if (type === "config") {
            setModalConfigs((prevState: any) => ({
                ...prevState,
                [modalConfigs?.type]: {
                    ...modalConfigs[modalConfigs?.type || "Text"],
                    [name]: value
                }
            }));
        } else if (type === "type"){
            setModalConfigs((prevState: any) => ({
                ...prevState,
                type: value
            }));
        } else {
            if(name==="font"){
                value['font-size'] = value?.size+"px";
                value['font-weight'] = `${value?.weight}`;
                value["text-align"]=`${value?.alignment}`;
                value["text-decoration"]=`${value?.decoration}`;
                value["text-transform"]=`${value?.case}`;
                value["letter-spacing"]=value?.letterSpacing+"px";
                setModalConfigs((prevState: any) => ({
                    ...prevState,
                    [modalConfigs?.type]: {
                        ...modalConfigs[modalConfigs?.type|| "Text"],
                         styles: {
                            ...modalConfigs[modalConfigs?.type|| "Text"]?.styles,
                            ...value
                        }
                    }
                }));
            }
            else
                setModalConfigs((prevState: any) => ({
                    ...prevState,
                    [modalConfigs?.type]: {
                        ...modalConfigs[modalConfigs?.type || "Text"],
                        styles: {
                            ...modalConfigs[modalConfigs?.type || "Text"]?.styles,
                            [name]: value
                        }
                    }
                }));
        }
        setErrMessage("");
    };

    const reset = () => {
        setModalConfigs({
            type: '',
            [type]: {}
        });
        dispatch(onsetClrPicContext({
            value: "#666980",
            where: 'background',
            visibility: false,
            type: "addExpansion_newSetup"
        }));
        setErrMessage("");
    };

    return (
        <div className="w-full" style={{marginTop: 10}}>
            <div className="w-full bg-transparent">
                <div style={{
                    display: "flex", alignItems: "center",
                    justifyContent: "space-between"
                }}>
                    <label style={{ fontWeight: 700, fontSize: "11px", color: "#111827" }}>
                        {config?.customExpansion?.mode === "TabBar" && "Add tab" ||
                            config?.customExpansion?.mode === "Table" && "Highlight cell" ||
                            config?.customExpansion?.mode === "Segments" && "Add segments" ||
                            config?.customExpansion?.mode === "Table" && "Highlight cell" ||
                            config?.customExpansion?.mode === "TimeLine" && "Add section" ||
                            config?.customExpansion?.mode === "WizardSteps" && "Wizard Steps" ||
                            config?.customExpansion?.mode === "Modal" && "Add content type"
                        }
                    </label>
                    {!tabAddMode ?
                        <button onClick={(() => {
                            if (props.type === "Stepper" && timeLineFields.length < props.stepperCount) {
                                setTabAddMode(true)
                                setShowError(false)
                            } else if (props.type !== "Stepper") {
                                setTabAddMode(true)
                                setShowError(false)
                            } else {
                                setShowError(true)
                            }
                        }
                        )} type="button"
                            style={{
                                outline: "none", background: "#052f35 ",
                                borderRadius: "50px",display:"flex",alignItems:"center",justifyContent:"center",
                                color: "white", cursor: "pointer",width:"41px",height:"21px",fontSize:"10px",fontWeight:700
                            }}>ADD</button>
                        : <div>
                            <button onClick={(() => { resetAllStates() })}
                                style={{
                                    outline: "none", background: "none",color: "#969BA5", padding: "4px 9px", cursor: "pointer",
                                    fontWeight: 700,fontSize:"10px",lineHeight: "13px",textTransform:"uppercase"
                                }}>Cancel</button>
                            <button onClick={(() => {
                                config?.customExpansion?.mode === "TabBar" && addTab() ||
                                config?.customExpansion?.mode === "Table" && addCondition() ||
                                config?.customExpansion?.mode === "Segments" && addSegments() ||
                                config?.customExpansion?.mode === "TimeLine" && addTimeLineFields() ||
                                config?.customExpansion?.mode === "WizardSteps" && addWizardSteps() ||
                                config?.customExpansion?.mode === "Modal" && addModalContent()
                            })} type="button"
                                style={{
                                    outline: "none", background: "#052f35 ",borderRadius: "50px",color: "white", cursor: "pointer",
                                    width:"56px",height:"21px",fontSize:"10px",fontWeight:700
                                }}>SUBMIT</button>
                        </div>
                    }
                </div>
                {
                    config?.customExpansion?.mode === "TabBar" &&
                    <TabBarExpansionFields
                        tabAddMode={tabAddMode}
                        setTabData={setTabData}
                        ErrMessage={ErrMessage}
                        component={component}
                        components={components}
                        removeSelectedElement={removeSelectedElement}
                        handleChangeTab={handleChangeTab}
                        properties={properties}
                        openCodeEditorModal={openCodeEditorModal}
                        setEditorContext={setEditorContext}
                        editorContext={editorContext}
                    />
                }
                {
                    config?.customExpansion?.mode === "Table" &&
                    <TableExpansionPanel
                        setConditionFields={(item: any) => setConditionFields(item)}
                        removeCondition={(e: any, item: any) => removeCondition(e, item)}
                        setColorPickerContext={(items: any) => setColorPickerContext(items)}
                        conditionFields={conditionFields}
                        conditions={cellConditions}
                        tabAddMode={tabAddMode}
                        isCheckedIn={props.isCheckedIn}
                        handleChange={handleChange}
                    />
                }
                {
                    config?.customExpansion?.mode === "Segments" &&

                    <SegmentsExpansionPanel
                        segmentLabel={segmentLabel}
                        setSegmentLabel={setSegmentLabel}
                        setSegmentFields={setSegmentFields}
                        segmentFields={segmentFields}
                        propsSegments={propsSegments}
                        removeSegment={(e: any, item: any) => removeSegment(e, item)}
                        segments={properties?.segments}
                        properties={properties}
                        tabAddMode={tabAddMode}
                        ErrMessage={ErrMessage}
                        setErrMessage={setErrMessage}
                        isCheckedIn={props.isCheckedIn}
                        handleChange={handleChange}
                        setEditorContext={setEditorContext}
                        editorContext={editorContext}
                        functionsdef={functionsdef}
                        openCodeEditorModal={openCodeEditorModal}
                        selectedElementId={selectedElementId}
                    />
                }
                {
                    config?.customExpansion?.mode === "TimeLine" &&
                    <TimeLineExtensionPanel
                        {...props}
                        showError={showError}
                        setConditionFields={(item: any) => setTimeLineFields(item)}
                        removeCondition={(e: any, item: any) => removeTimeLineFields(e, item)}
                        setColorPickerContext={(items: any) => setColorPickerContext(items)}
                        conditionFields={timeLineFields}
                        conditions={timeLineValues}
                        tabAddMode={tabAddMode}
                        isCheckedIn={props.isCheckedIn}
                        handleChange={handleChange}
                    />
                }
                {
                    config?.customExpansion?.mode === "WizardSteps" &&
                    <WizardStepsExtensionPanel
                        wizardTitle={wizardTitle}
                        wizardDescription={wizardDescription}
                        setWizardTitle={setWizardTitle}
                        setWizardDescription={setWizardDescription}
                        setWizardSteps={setWizardSteps}
                        handleChangeWizard={handleChangeWizard}
                        component={component}
                        components={components}
                        removewizardSteps={removeWizardSteps}
                        properties={properties}
                        tabAddMode={tabAddMode}
                        ErrMessage={ErrMessage}
                        setErrMessage={setErrMessage}
                        selectedElementId={selectedElementId}
                    />
                }
                {
                    config?.customExpansion?.mode === "Modal" &&
                    <ModalExpansionPanel
                        setConditionFields={(item: any) => setConditionFields(item)}
                        setColorPickerContext={(items: any) => setColorPickerContext(items)}
                        tabAddMode={tabAddMode}
                        isCheckedIn={props.isCheckedIn}
                        handleChange={handleChange}
                        ErrMessage={ErrMessage}
                        onModalChange={onModalChange}
                        modalConfigs={modalConfigs}
                    />
                }
            </div>
        </div>
    )
})

interface IProps {
    checked: boolean,
    onChange: (changeValue: boolean) => void,
    id: string,
    label: string
}
export const Checkbox = ((props: IProps) => {
    const { checked, onChange, id, label } = props
    const isSelected = checked === true ? true : false
    return (
        <div className="panel-div">
            <div className="panel-label"></div>
            <div className="flex items-center" style={{ width: 170 }}>
                <div
                    id={id}
                    style={{
                        display: "block", width: "15px", minWidth: 15, height: "15px", border: "1px solid rgba(125, 132, 146, 0.294)", cursor: "pointer",
                        boxSizing: "border-box", background: isSelected ? "#0466C8" : "#FFFFFF", borderRadius: "4px", justifyContent: "center", pointerEvents: "initial"
                    }}
                    className="focus:outline-none"
                    onClick={(() => { onChange(!isSelected) })}
                >
                    {isSelected && (
                        <div style={{ marginTop: "-2px", marginLeft: "-1px", display: "flex", alignItems: "center", width: "inherit", height: "inherit" }}>
                            <svg viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 7.62163L6.62162 9.24325L9.86487 6.00001" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg></div>
                    )}
                </div>
                <label
                    onClick={(() => { onChange(!isSelected) })}
                    htmlFor={id}
                    className="checkbox-label"
                    style={{ fontWeight: isSelected ? 700 : 600 }}
                >
                    <span>{label}</span>
                </label>
            </div>
        </div>
    );
})
export const TabBarExpansionFields = ((props: any) => {
    const { tabAddMode, setTabData, ErrMessage, component, components, removeSelectedElement, handleChangeTab, properties, setEditorContext, editorContext } = props;
    const params: any = useParams();
    const [functionsdef, setFunctionsdef] = useState<any>();
    const version = useSelector(
        (state: any) => state.apps.appVersion[params["appId"]]
    );
    const openCodeEditorModal = async () => {
        let data = await getFunctions(params["appId"], version.versionId);
        setFunctionsdef(data);
    }
    const setEditorVisibility = (visibility: boolean) => {
        setEditorContext((prevState: any) => ({ ...prevState, visibility }))
    }
    const [hideOnElementsValue, setHideOnElementsValue] = useDebouncedAction(component?.properties && component?.properties?.config?.visibilityCondition);
    const [originalConfig, setOriginalConfig] = useState<any>({});
    const [tabId, setTabId] = useState('');
    const dispatch = useDispatch();

    const OnClick = async (id: string, source: string) => {
        await openCodeEditorModal()
        setEditorContext({
            visibility: true,
            source: source || `async function main(asset) {\n      // Start of editable area\n      \n      // End of editable area\n    }`,
            where: `${id}.tab.onload`,
        })
    }

    const handleChange = (fieldId: string, path: string, value: string | number | boolean) => {
        const key = path.split(".").pop();
        if (key) {
            myUndoStack.push({
                id: fieldId,
                path,
                value: originalConfig[key],
                label: "",
                properties: {},
                fields: [],
                type: ""
            });
            dispatch(
                updateElement({
                    id: fieldId,
                    path,
                    value,
                })
            );
            dispatch(pushFormActionStack({
                undo: () => {
                    const poppedElement = myUndoStack.pop();
                    if (poppedElement) {
                        myRedoStack.push({ ...poppedElement, value })
                        dispatch(updateElementOnUndoRedo({
                            id: poppedElement.id,
                            path: poppedElement.path,
                            value: poppedElement.value,
                            increment: -1
                        }))
                    }
                },
                redo: () => {
                    const poppedElement = myRedoStack.pop();
                    if (poppedElement) {
                        myUndoStack.push({ ...poppedElement, value: originalConfig[key] });
                        dispatch(updateElementOnUndoRedo({
                            id: poppedElement.id,
                            path: poppedElement.path,
                            value: poppedElement.value,
                            increment: 1
                        }))
                    }
                }
            }));
            setOriginalConfig(update(originalConfig, { [key]: { $set: value } }));
        }


    };
    const handleIdChangeOnBlur = (oldId: any, newId: any) => {
        if (oldId && newId !== oldId) {
          let allIds = Object.keys(components)
          let matchedId = allIds.filter(id => id === newId);
          if (!matchedId.length) {
            // Undo Redo for Id
            myUndoStack.push({
              id: oldId, // old Id
              fields: [],
              label: "",
              properties: {},
              type: "",
              value: newId // new Id
            });
    
            myRedoStack.clear();
            dispatch(updateTabId(oldId, newId));
    
            dispatch(pushFormActionStack({
              undo: () => {
                const poppedElement = myUndoStack.pop();
                if (poppedElement) {
                  myRedoStack.push({ ...poppedElement, id: oldId, value: newId })
                  dispatch(updateTabId(poppedElement.value, poppedElement.id, -1))
                }
              },
              redo: () => {
                const poppedElement = myRedoStack.pop();
                if (poppedElement) {
                  myUndoStack.push({ ...poppedElement });
                  dispatch(updateTabId(poppedElement.id, poppedElement.value, 1))
                }
              }
            }))
          }
        }
      }
    return (
        <>
            {
                tabAddMode &&
                <div style={{ display: "flex", gap: "10px", width: "100%", marginTop: "10px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", flexDirection: "column", width: "100%" }}>
                        <input
                            style={{width: "100%"}}
                            type={"text"}
                            className="panel-input"
                            placeholder={"Enter tab label"}
                            onChange={e => {
                                const changeValue = e.target.value
                                setTabData((prevState: any) => ({ ...prevState, ["key"]: changeValue }))
                            }}
                        />
                    </div>
                </div>
            }
            {ErrMessage && (
                <p
                    data-test-id="validation_error_message"
                    style={{ color: "red", textAlign: "left", marginTop: "10px" }}
                >
                    {ErrMessage}
                </p>
            )}
            {
                component?.fields && component?.fields.map((fieldId: any, index: any) => {
                    const element = components[fieldId];
                    return (
                        <div style={{ marginTop: "10px",width:"278px" }}>
                            <Disclosure>
                                {({ open }) => (
                                    <>
                                        <Disclosure.Button style={{ height: "28px",width:"278px", padding: "8px", borderRadius: "4px", background: "#EFF0F4", color: "#505F7B" }} 
                                        className="flex justify-between bg-gray-100 text-left text-purple-900  text-xs font-semibold items-center hover:bg-purple-200 p-2 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                                            <span className="truncate" style={{fontSize:"12px", fontWeight:600, lineHeight: "normal"}}>{element.label}</span>
                                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                {
                                                    component?.fields.length > 1 && <Delete onClick={(e: any) => removeSelectedElement(e, fieldId)} />
                                                }
                                                <span>
                                                    {
                                                        open ? <Up></Up> : <Down></Down>
                                                    }
                                                </span>
                                            </div>
                                        </Disclosure.Button>
                                        <Transition
                                            show={open}
                                            enter="transition duration-100 ease-out"
                                            enterFrom="transform scale-95 opacity-0"
                                            enterTo="transform scale-100 opacity-100"
                                            leave="transition duration-75 ease-out"
                                            leaveFrom="transform scale-100 opacity-100"
                                            leaveTo="transform scale-95 opacity-0"
                                        >
                                            <div style={{ border: "1.5px solid #EFF0F4", borderTop: "none", padding: "0px 5px 9px", borderTopLeftRadius: "0px", borderTopRightRadius: "0px", borderBottomRightRadius: "4px", borderBottomLeftRadius: "4px" }}>
                                                <Disclosure.Panel static>
                                                <div className="panel-div">
                                                        <label	
                                                            htmlFor={`Tab_Id_${index}`}	
                                                            className="panel-label">
                                                            Id
                                                        </label>
                                                        <input
                                                            type={"text"}
                                                            id={`Tab_Id_${index}`}
                                                            defaultValue={element?.id}
                                                            className="panel-input"
                                                            placeholder={"Enter id"}
                                                            onChange={e => {
                                                                const changeValue = e.target.value
                                                                setTabId(changeValue);
                                                            }}
                                                            onBlur={(e) => {
                                                                handleIdChangeOnBlur(element?.id, e.target.value)
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="panel-div">	
                                                        <label
                                                            htmlFor={`Tab_label_${index}`}
                                                            className="panel-label"
                                                        >
                                                            Label
                                                        </label>
                                                        <input
                                                            type={"text"}
                                                            id={`Tab_label_${index}`}
                                                            value={element?.label}
                                                            className="panel-input"
                                                            placeholder={"Enter key"}
                                                            onChange={e => {
                                                                const changeValue = e.target.value
                                                                handleChangeTab(fieldId, "label", changeValue)
                                                            }}
                                                        />
                                                    </div>
                                                    <Checkbox
                                                        id={`Tab_visible_${index}`}
                                                        checked={element?.properties.config.visible}
                                                        onChange={(changeValue) => {
                                                            handleChange(fieldId, `properties.config.visible`, changeValue)
                                                        }}
                                                        label="Visible"
                                                    />
                                                    <Checkbox
                                                        id={`Tab_Disable_${index}`}
                                                        checked={element?.tabDisable}
                                                        onChange={changeValue => {
                                                            handleChangeTab(fieldId, "tabDisable", changeValue)
                                                        }}
                                                        label="Disable"
                                                    />
                                                    <div style={{ marginTop: "10px" }} className="flex justify-between items-center cursor-pointer">	
                                                        <label	
                                                            htmlFor={`Tab_visibility_${index}`}	
                                                            style={{ fontSize: "11px", lineHeight: "14px", color: "#111827" }}	
                                                            className="block py-1 font-semibold"
                                                        >
                                                            {`${!element?.properties.config.visible ? "Show" : "Hide"} On`}
                                                        </label>
                                                        <input
                                                            type="text"
                                                            id={`Tab_visibility_${index}`}
                                                            value={element?.properties.config.visibilityCondition}
                                                            className="panel-input"
                                                            placeholder="eg: bindParam === 'value'"
                                                            onChange={e => {
                                                                const value = e.target.value;
                                                                handleChange(fieldId, `properties.config.visibilityCondition`, value)
                                                            }}
                                                        />
                                                    </div>
                                                    {
                                                        properties?.tapType !== "text-only" ?
                                                            <>
                                                                <div style={{ marginTop: "10px" }} className="flex justify-between items-center cursor-pointer">
                                                                    <label
                                                                        htmlFor={`Tab_SelectedUrl_${index}`}
                                                                        className="panel-label"
                                                                    >
                                                                        Selected icon
                                                                    </label>
                                                                    <input
                                                                        type={"text"}
                                                                        id={`Tab_SelectedUrl_${index}`}
                                                                        value={element?.selectedIconUrl || ""}
                                                                        className="panel-input"
                                                                        placeholder={"Enter icon url"}
                                                                        onChange={e => {
                                                                            const changeValue = e.target.value
                                                                            handleChangeTab(fieldId, "selectedIconUrl", changeValue)
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div style={{ marginTop: "10px" }} className="flex justify-between items-center cursor-pointer">
                                                                    <label
                                                                        htmlFor={`Tab_UnselectedUrl_${index}`}
                                                                        className="panel-label"
                                                                    >
                                                                        Unselected icon
                                                                    </label>
                                                                    <input
                                                                        type={"text"}
                                                                        id={`Tab_UnselectedUrl_${index}`}
                                                                        value={element?.unSelectedIconUrl || ""}
                                                                        className="panel-input"
                                                                        placeholder={"Enter icon url"}
                                                                        onChange={e => {
                                                                            const changeValue = e.target.value
                                                                            handleChangeTab(fieldId, "unSelectedIconUrl", changeValue)
                                                                        }}
                                                                    />
                                                                </div>
                                                            </> : <></>
                                                    }
                                                    {/* <div style={{ marginLeft: "3px", marginRight: "5px", marginTop: "8px", gap: "27px" }} className="grid grid-cols-4 items-center" key={index}>	 */}
                                                    <Wrapper key={`Tab_Onload_${index}`}>
                                                        <p className="panel-label">On load</p>
                                                        <p
                                                            className="flex items-center font-medium rounded-md cursor-pointer"
                                                            style={{
                                                                color: "#0466C8",
                                                                backgroundColor: "rgba(4, 102, 200, 0.1)",
                                                                height: "28px",
                                                                width: "170px",
                                                                padding: "5px"
                                                            }}
                                                            onClick={() => OnClick(fieldId, element?.onload)}
                                                        >
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    alignItems: "center",
                                                                    width: "100%"
                                                                }}
                                                            >
                                                                <span>On load</span>
                                                                <img src={EditorIcon} alt="editorIcon" />
                                                            </div>
                                                        </p>
                                                    </Wrapper>
                                                    <Wrapper key={`Tab_OnSwitch_${index}`}>
                                                        <p className="panel-label">On switch</p>
                                                        <p
                                                            className="flex items-center font-medium rounded-md cursor-pointer"
                                                            style={{
                                                                color: "#0466C8",
                                                                backgroundColor: "rgba(4, 102, 200, 0.1)",
                                                                height: "28px",
                                                                width: "170px",
                                                                padding: "5px"
                                                            }}
                                                            onClick={async () => {
                                                                await openCodeEditorModal()
                                                                setEditorContext({
                                                                    visibility: true,
                                                                    source: element?.onTabSwitch || `async function main(asset) {\n      // Start of editable area\n      \n      // End of editable area\n    }`,
                                                                    where: `${fieldId}.tab.onTabSwitch`,
                                                                })
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    alignItems: "center",
                                                                    width: "100%"
                                                                }}
                                                            >
                                                                <span>On switch</span>
                                                                <img src={EditorIcon} alt="editorIcon" />
                                                            </div>
                                                        </p>
                                                    </Wrapper>
                                                </Disclosure.Panel>
                                            </div>
                                        </Transition>
                                    </>
                                )}
                            </Disclosure>
                        </div>
                    )
                })
            }
            {
                editorContext.visibility ? (
                    <EditorPanel type="inline" customdef={functionsdef} isCheckedIn={true} close={() => setEditorVisibility(false)} editorContext={editorContext} />
                ) : null
            }
        </>
    )
})

export const TableExpansionPanel = (props: any) => {
    const { setConditionFields, conditionFields, removeCondition, setColorPickerContext } = props
    const { savedTemplate } = useSelector((state: any) => state)
    const { colorPickerContext } = useSelector((state: any) => state.common);
    const dispatch = useDispatch()

    const ConditionsChanges = (data: any) => {
        let tempCConditions = props.conditions
        let path = tempCConditions[data.idx].conditionFields
        path[data.type] = data.value
        props.handleChange(`properties.config.cellConditions`, tempCConditions)
    }

    return (
        <div className="w-full">
            <div className="w-full bg-transparent">
                {
                    props.tabAddMode &&
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <div className="panel-div">
                            <div style={{
                                width: "60px", display: "flex",
                                alignItems: "center", fontWeight: 500,
                                fontSize: "11px", color: "#111827"
                            }} >{"Col-id"}</div>
                            <input
                                value={conditionFields && conditionFields?.col_id}
                                className="panel-input outline-none" placeholder="eg: colid12"
                                onChange={(e: any) => setConditionFields({ ...conditionFields, col_id: e.target.value })}>
                            </input>
                        </div>
                        <div className="panel-div">
                            <div style={{
                                width: "60px", display: "flex",
                                alignItems: "center", fontWeight: 500,
                                fontSize: "11px", color: "#111827"
                            }} >{"Expression"}</div>
                            <input
                                value={conditionFields && conditionFields?.expression}
                                className="panel-input outline-none" placeholder="eg: {value} > 30 or {value} == 10"
                                onChange={(e: any) => setConditionFields({ ...conditionFields, expression: e.target.value })}
                            ></input>
                        </div>
                        <ColorPicker pickerkey={"table-bgColor"} label={"Bg color"} value={savedTemplate && savedTemplate?.condition_background || "#70AD47"} open={()=>dispatch(onsetClrPicContext({
                                        value: savedTemplate && savedTemplate?.condition_background || "#70AD47",
                                        where: 'background',
                                        visibility: true,
                                        type: "addExpansion_newSetup"
                                    }))} close={()=>dispatch(onsetClrPicContext({ ...colorPickerContext, visibility: false }))} 
                                    visibility={colorPickerContext?.visibility}
                                    />
                        <ColorPicker pickerkey="table-text" label="Text Color" value={savedTemplate && savedTemplate?.condition_color || "#EAFFDC"} open={()=>
                            dispatch(onsetClrPicContext({
                                value: savedTemplate && savedTemplate?.condition_color || "#EAFFDC",
                                where: 'color',
                                visibility: true,
                                type: "addExpansion_newSetup"
                            }))
                        } close={()=>dispatch(onsetClrPicContext({ ...colorPickerContext, visibility: false }))}
                           visibility={colorPickerContext?.visibility} 
                         />
                    </div>
                }
                {
                    props.conditions && props.conditions?.length > 0 && props.conditions.map((items: any, i: number) => {
                        let conditionFields = items.conditionFields
                        return (
                            <div key={i} style={{marginTop:10}} >
                                <Disclosure>
                                    {({ open }) => (
                                        <>
                                            <Disclosure.Button style={{ height: "34px", alignItems: "center", fontSize: "12px", fontWeight: 700, padding: "8px", borderRadius: "4px", background: "#EFF0F4", color: "#505F7B" }}
                                                className="flex w-full justify-between rounded-sm  text-left  text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                                                <span>{`Condition ${i + 1}`}</span>
                                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                    <Delete height="15px" onClick={(e: any) => removeCondition(e, items)} />
                                                    <span>
                                                        {
                                                            open ? <Up></Up> : <Down></Down>
                                                        }
                                                    </span>
                                                </div>
                                            </Disclosure.Button>
                                            <Transition
                                                show={open}
                                                enter="transition duration-100 ease-out"
                                                enterFrom="transform scale-95 opacity-0"
                                                enterTo="transform scale-100 opacity-100"
                                                leave="transition duration-75 ease-out"
                                                leaveFrom="transform scale-100 opacity-100"
                                                leaveTo="transform scale-95 opacity-0"
                                            >
                                                <div style={{ border: "1.5px solid #EFF0F4", borderTop: "none", padding: "10px 5px", borderTopLeftRadius: "0px", borderTopRightRadius: "0px", borderBottomRightRadius: "4px", borderBottomLeftRadius: "4px" }}>
                                                    <Disclosure.Panel static>
                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                            <div className="panel-div">
                                                                <div className="panel-label">{"Col-id"}</div>
                                                                <input className="panel-input outline-none" placeholder="eg: colid12, colid23,"
                                                                    onChange={(event: any) => ConditionsChanges({ type: "col_id", value: event.target.value, idx: i })}
                                                                    value={conditionFields && conditionFields?.col_id}
                                                                ></input>
                                                            </div>
                                                            <div className="panel-div">
                                                                <div className="panel-label">{"Expression"}</div>
                                                                <input className="panel-input outline-none" placeholder="eg: {value} > 30 or {value} == 10"
                                                                    onChange={(event: any) => ConditionsChanges({ type: "expression", value: event.target.value, idx: i })}
                                                                    value={conditionFields && conditionFields?.expression}
                                                                ></input>
                                                            </div>
                                                            <ColorPicker
                                                                    pickerkey="table-Bg" label="Bg color" value={conditionFields && conditionFields?.background} open={()=>
                                                                        dispatch(onsetClrPicContext({
                                                                            value: conditionFields && conditionFields?.font_color,
                                                                            where: 'background',
                                                                            visibility: true,
                                                                            idx: i,
                                                                            type: "addExpansion"
                                                                        }))
                                                                    } 
                                                                    close={()=>dispatch(onsetClrPicContext({ ...colorPickerContext, visibility: false }))}
                                                                    visibility={colorPickerContext?.visibility}
                                                            />
                                                            <ColorPicker pickerkey="table-text" label="Text color" value={conditionFields && conditionFields?.color} open={()=>
                                                                dispatch(onsetClrPicContext({
                                                                    value: conditionFields?.color,
                                                                    where: 'color',
                                                                    visibility: true,
                                                                    idx: i,
                                                                    type: "addExpansion"
                                                                }))
                                                            }
                                                            visibility={colorPickerContext?.visibility}
                                                            close={()=>dispatch(onsetClrPicContext({ ...colorPickerContext, visibility: false }))}
                                                             />
                                                        </div>
                                                    </Disclosure.Panel>
                                                </div>
                                            </Transition>
                                        </>
                                    )}
                                </Disclosure>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export const TimeLineExtensionPanel = (props: any) => {
    const [visibility, setVisibility] = useState(false)
    const [description, setDiscription]: any = useState("")
    const { setConditionFields, conditionFields, removeCondition, setColorPickerContext, showError, conditions } = props
    const { savedTemplate } = useSelector((state: any) => state)
    const dispatch = useDispatch()
    const [functionsdef, setFunctionsdef] = useState<any>();
    const { colorPickerContext } = useSelector((state: any) => state.common);
    const [editorContext, setEditorContext] = useState({
        visibility: false,
        id: 0,
        source: "",
        type: "",
        where: "",
    });
    const [blurState, setBlurState] = useState({
        title: false,
        subTitle: false,
        desc: false,
        badge: false,
        label: false,
    })
    const [onOpenBlurState, setOnOpenBlurState] = useState<any>({
        title: {},
        subTitle: {},
        desc: {},
        badge: {},
        label: {},
    })
    
    const defaultEditorValue = `async function main (){
    // Start of editable area
                                                                                 
    // End of editable area
    }`
    const [editDescription, setEditDescription] = useState(false)

    const setEditorVisibility = (visibility: boolean) => {
        setEditorContext((prevState) => ({ ...prevState, visibility }));
    };
    

    const params: any = useParams();
    const version = useSelector(
        (state: any) => state.apps.appVersion[params["appId"]]
    );

    const openCodeEditorModal = async () => {
        let data = await getFunctions(params["appId"], version.versionId);
        setFunctionsdef(data);
    };

    const ConditionsChanges = (data: any) => {
        let tempCConditions = props.conditions
        let path = tempCConditions[data.idx].timeLineFields
        if (!path.desc || !path.label) {
            if (data.field) {
                if (!path[data?.type]) {
                    path[data?.type] = {}
                }
                path[data.type][data.field] = data.value
            } else {
                path[data.type] = data.value
            }
        } else {
            if (data.field) {
                if (!path[data.type]) {
                    path[data.type] = {}
                    path[data.type][data.field] = data.value
                }
                path[data.type][data.field] = data.value
            } else {
                path[data.type] = data.value
            }
        }
        props.handleChange(`properties.config.section`, tempCConditions)
    }


    useEffect(() => {
        props.conditions && props.conditions?.length > 0 && props.conditions.map((s: any, i: number) => {
            setOnOpenBlurState({
                ...onOpenBlurState, desc: { ...onOpenBlurState.desc, [i]: false },
                title: { ...onOpenBlurState.title, [i]: false },
                subTitle: { ...onOpenBlurState.subTitle, [i]: false },
                badge: { ...onOpenBlurState.badge, [i]: false },
                label: { ...onOpenBlurState.label, [i]: false }
            })

        })
    }, [])

    return (
        <div className="w-full">
            <div className="w-full bg-transparent">
                {showError && <div style={{ color: "red" }}>{`you can add ${props.stepperCount} sections only`}</div>}
                {
                    props.tabAddMode &&
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <div className="panel-div">
                            <div className="panel-label">{"Label"}</div>
                             {blurState.label ?
                                    <div onClick={() => setBlurState({...blurState,label:false})}>
                                        <I18AutoCompletion dataTestId="label"
                                            value={conditionFields && conditionFields?.label} />
                                    </div>
                                    :
                                    <CustomAutoComplete
                                        dataTestId="label"
                                        disabled={!props.isCheckedIn}
                                        value={conditionFields && conditionFields?.label}
                                        onChange={(val) => {
                                            setConditionFields({ ...conditionFields, label: val })
                                        }}
                                        onSelect={(val) => {
                                            setConditionFields({ ...conditionFields, label: val })
                                        }}
                                        onBlur={() => setBlurState({...blurState,label:true})}
                                    />
                                }
                        </div>
                        <div className="panel-div">
                            <div className="panel-label">{"Padding"}</div>
                            <input
                                value={conditionFields && conditionFields?.padding}
                                className="panel-input" placeholder="eg: 5"
                                onChange={(e: any) => { setConditionFields({ ...conditionFields, padding: e.target.value }) }}
                            ></input>
                        </div>
                        <div style={{margin:"10px 0px"}}><hr></hr></div>
                            <div className="panel-div">
                                <div className="panel-label">{"Badge"}</div>
                            </div>
                            <div className="panel-div">
                                <div className="panel-label">{"Icon"}</div>
                                <input
                                    value={conditionFields && conditionFields?.badge?.icon || ""}
                                    className="panel-input" placeholder="Enter the icon url"
                                    onChange={(e: any) => setConditionFields({ ...conditionFields, badge: { ...conditionFields.badge, icon: e.target.value } })}
                                ></input>
                            </div>
                            <div className="panel-div">
                                <div className="panel-label">{"Text"}</div>
                                {blurState.badge ?
                                    <div onClick={() => setBlurState({...blurState,badge:false})}>
                                        <I18AutoCompletion dataTestId="label"
                                            value={conditionFields && conditionFields?.badge?.text || ""} />
                                    </div>
                                    :
                                    <CustomAutoComplete
                                        dataTestId="label"
                                        disabled={!props.isCheckedIn}
                                        value={conditionFields && conditionFields?.badge?.text || ""}
                                        onChange={(val) => {
                                            setConditionFields({ ...conditionFields, badge: { ...conditionFields.badge, text: val } })
                                        }}
                                        onSelect={(val) => {
                                           setConditionFields({ ...conditionFields, badge: { ...conditionFields.badge, text: val } })
                                        }}
                                        onBlur={() => setBlurState({...blurState,badge:true})}
                                    />
                                }
                              
                            </div>
                            <div className="panel-div">
                                <div className="panel-label">{"Font size"}</div>
                                <input
                                    value={conditionFields && conditionFields?.badge?.fontSize || ""}
                                    className="panel-input" placeholder="eg: 5"
                                    onChange={(e: any) => setConditionFields({ ...conditionFields, badge: { ...conditionFields.badge, fontSize: e.target.value } })}
                                ></input>
                            </div>
                        <div className="panel-div">
                            <div className="panel-label">{"Font weight"}</div>
                            <input
                                value={conditionFields && conditionFields?.badge?.fontWeight || ""}
                                className="panel-input" placeholder="eg :500"
                                onChange={(e: any) => setConditionFields({ ...conditionFields, badge: { ...conditionFields.badge, fontWeight: e.target.value } })}
                            ></input>
                        </div>
                            <ColorPicker pickerkey="fontcolor" label="Font color" value={conditionFields?.badge?.fontColor || "#121212"} open={() => dispatch(onsetClrPicContext({
                                type: "addExtension_TimeLine",
                                value: conditionFields?.badge?.fontColor || "#121212",
                                where: 'badgeFontColor',
                                idx: conditions?.length + 1,
                                visibility: true
                            }))} close={() => dispatch(onsetClrPicContext({ ...colorPickerContext, visibility: false }))}
                                visibility={colorPickerContext?.visibility} />
                        <hr style={{ width: "100%", marginTop: "10px" }} />
                        <div className="panel-div">
                            <div className="panel-label">{"Title"}</div>
                                {blurState.title ?
                                    <div onClick={() => setBlurState({...blurState,title:false})}>
                                        <I18AutoCompletion dataTestId="label"
                                            value={conditionFields && conditionFields?.title?.text || ""} />
                                    </div>
                                    :
                                    <CustomAutoComplete
                                        dataTestId="label"
                                        disabled={!props.isCheckedIn}
                                        value={conditionFields && conditionFields?.title?.text || ""}
                                        onChange={(val) => {
                                            setConditionFields({ ...conditionFields, title: { ...conditionFields.title, text: val } })
                                        }}
                                        onSelect={(val) => {
                                            setConditionFields({ ...conditionFields, title: { ...conditionFields.title, text: val } })
                                        }}
                                        onBlur={() => setBlurState({...blurState,title:true})}
                                    />
                                }
                        </div>
                        {/* title color works in status based */}
                        {/* <div className="panel-div">
                            <div className="panel-label">{"Font size"}</div>
                            <input
                                value={conditionFields && conditionFields?.title?.fontSize || ""}
                                className="panel-input" placeholder="eg: 5"
                                onChange={(e: any) => setConditionFields({ ...conditionFields, title: { ...conditionFields.title, fontSize: e.target.value } })}
                            ></input>
                        </div> */}
                        {/* <div className="panel-div">
                            <div className="panel-label">{"Font weight"}</div>
                            <input
                                value={conditionFields && conditionFields?.title?.fontWeight || ""}
                                className="panel-input" placeholder="eg :500"
                                onChange={(e: any) => setConditionFields({ ...conditionFields, title: { ...conditionFields.title, fontWeight: e.target.value } })}
                            ></input>
                        </div> */}
                            {/* <ColorPicker pickerkey="fontcolor" label="Font color" value={conditionFields?.title?.fontColor || "#121212"} open={() => dispatch(onsetClrPicContext({
                                type: "addExtension_TimeLine",
                                value: conditionFields?.title?.fontColor || "#121212",
                                where: 'titleFontColor',
                                idx: conditions?.length + 1,
                                visibility: true
                            }))} close={() => dispatch(onsetClrPicContext({ ...colorPickerContext, visibility: false }))}
                                visibility={colorPickerContext?.visibility} />
                                <hr style={{ width: "100%", marginTop: "10px" }} /> */}
                        <div className="panel-div">
                            <div className="panel-label">{"Sub-title"}</div>
                             {blurState.subTitle ?
                                    <div onClick={() => setBlurState({...blurState,subTitle:false})}>
                                        <I18AutoCompletion dataTestId="label"
                                            value={conditionFields && conditionFields?.subTitle?.text || ""} />
                                    </div>
                                    :
                                    <CustomAutoComplete
                                        dataTestId="label"
                                        disabled={!props.isCheckedIn}
                                        value={conditionFields && conditionFields?.subTitle?.text || ""}
                                        onChange={(val) => {
                                            setConditionFields({ ...conditionFields, subTitle: { ...conditionFields.subTitle, text: val } })
                                        }}
                                        onSelect={(val) => {
                                            setConditionFields({ ...conditionFields, subTitle: { ...conditionFields.subTitle, text: val } })
                                        }}
                                        onBlur={() => setBlurState({...blurState,subTitle:true})}
                                    />
                                }
                                
                        </div>
                        <div className="panel-div">
                            <div className="panel-label">{"Font size"}</div>
                            <input
                                value={conditionFields && conditionFields?.subTitle?.fontSize || ""}
                                className="panel-input" placeholder="eg: 5"
                                onChange={(e: any) => setConditionFields({ ...conditionFields, subTitle: { ...conditionFields.subTitle, fontSize: e.target.value } })}
                            ></input>
                        </div>
                        <div className="panel-div">
                            <div className="panel-label">{"Font weight"}</div>
                            <input
                                value={conditionFields && conditionFields?.subTitle?.fontWeight || ""}
                                className="panel-input" placeholder="eg: 500"
                                onChange={(e: any) => setConditionFields({ ...conditionFields, subTitle: { ...conditionFields.subTitle, fontWeight: e.target.value } })}
                            ></input>
                        </div>
                            <ColorPicker pickerkey="fontcolor" label="Font color" value={conditionFields?.subTitle?.fontColor || "#121212"} open={() => dispatch(onsetClrPicContext({
                                type: "addExtension_TimeLine",
                                value: conditionFields?.subTitle?.fontColor || "#121212",
                                where: 'subTitleFontColor',
                                idx: conditions?.length + 1,
                                visibility: true
                            }))} close={() => dispatch(onsetClrPicContext({ ...colorPickerContext, visibility: false }))}
                                visibility={colorPickerContext?.visibility} />
                        <Wrapper>
                            <p className="panel-label">
                                {"Description"}
                            </p>
                            <p
                                className="col-span-2 font-medium rounded-md cursor-pointer "
                                style={{
                                    color: "#0466C8",
                                    backgroundColor: "rgba(4, 102, 200, 0.1)",
                                    height: "28px",
                                    width: "170px", 
                                    padding: "5px"
                                }}
                                onClick={() => { setVisibility(true); setEditDescription(false); setDiscription({ val: conditionFields?.desc || "" }) }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    {"Edit description"}
                                    {/* <img src={EditorIcon} alt="editorIcon" /> */}
                                </div>
                            </p>
                        </Wrapper>
                        <div className="panel-div">
                            <div style={{
                                width: "60px", display: "flex",
                                alignItems: "center",
                                fontSize: "11px", color: "#111827",
                                fontWeight: 600
                            }} >{"Font size"}</div>
                            <input
                                value={conditionFields && conditionFields?.descFontSize || ""}
                                className="panel-input" placeholder="eg: 5"
                                onChange={(e: any) => { setConditionFields({ ...conditionFields, descFontSize: e.target.value }) }}
                            ></input>
                        </div>
                            <ColorPicker pickerkey="fontcolor" label="Font color" value={conditionFields?.descFontColor || "#121212"} open={() => dispatch(onsetClrPicContext({
                                type: "addExtension_TimeLine",
                                value: conditionFields?.descFontColor || "#121212",
                                where: 'descFontColor',
                                idx: conditions?.length + 1,
                                visibility: true
                            }))} close={() => dispatch(onsetClrPicContext({ ...colorPickerContext, visibility: false }))} />
                        <div className="panel-div">
                            <div className="panel-label">{"Icon"}</div>
                            <input
                                value={conditionFields && conditionFields?.icon || ""}
                                className="panel-input" placeholder="eg: https://img.com/ico.p..."
                                onChange={(e: any) => { setDiscription(null); setConditionFields({ ...conditionFields, icon: e.target.value }) }}
                            ></input>
                        </div>
                        <Wrapper>
                            <p
                                style={{ color: "#111827", fontSize: 11 }}
                                className="block font-semibold py-1"
                            >
                                {"On click"}
                            </p>
                            <p
                                className="col-span-2 font-medium rounded-md cursor-pointer "
                                style={{
                                    color: "#0466C8",
                                    backgroundColor: "rgba(4, 102, 200, 0.1)",
                                    height: "28px",
                                    width: "170px",
                                    padding: "5px"
                                }}
                                onClick={async () => {
                                    // setColorPickerVisibility(false);
                                    await openCodeEditorModal();
                                    setEditorContext({
                                        visibility: true,
                                        source: conditionFields?.onClick || defaultEditorValue,
                                        type: "",
                                        id: 0,
                                        where: "onClick",
                                    });
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    {"On click"}
                                    <img src={EditorIcon} alt="editorIcon" />
                                </div>
                            </p>
                        </Wrapper>
                    </div>
                }
                {
                    props.conditions && props.conditions?.length > 0 && props.conditions.map((items: any, i: number) => {
                        let conditionFields = items.timeLineFields
                        return (
                            <div key={i} >
                                <Disclosure>
                                    {({ open }) => (
                                        <>
                                            <Disclosure.Button style={{ height: "34px", alignItems: "center", fontSize: "12px", fontWeight: 700, padding: "8px", borderRadius: "4px", background: "#EFF0F4", color: "#505F7B", marginTop: "10px" }}
                                                className="flex w-full justify-between rounded-sm  text-left  text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                                                <span>{conditionFields?.title?.text ? `${conditionFields?.title?.text}` : `Timeline${i + 1}`}</span>
                                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                    <Delete height="15px" onClick={(e: any) => removeCondition(e, items)} />
                                                    <span>
                                                        {
                                                            open ? <Up></Up> : <Down></Down>
                                                        }
                                                    </span>
                                                </div>
                                            </Disclosure.Button>
                                            <Transition
                                                show={open}
                                                enter="transition duration-100 ease-out"
                                                enterFrom="transform scale-95 opacity-0"
                                                enterTo="transform scale-100 opacity-100"
                                                leave="transition duration-75 ease-out"
                                                leaveFrom="transform scale-100 opacity-100"
                                                leaveTo="transform scale-95 opacity-0"
                                            >
                                                <div style={{ border: "1.5px solid #EFF0F4", borderTop: "none", padding: "0px 5px", borderTopLeftRadius: "0px", borderTopRightRadius: "0px", borderBottomRightRadius: "4px", borderBottomLeftRadius: "4px" }}>
                                                    <Disclosure.Panel static>
                                                        <div style={{ display: "flex", flexDirection: "column", paddingBottom: "10px" }}>
                                                            <div className="panel-div">
                                                                <div style={{
                                                                    width: "60px", display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                    fontSize: "11px", color: "#111827"
                                                                }} >{"Label"}</div>
                                                                {onOpenBlurState && onOpenBlurState.label[i] ?
                                                                    <div onClick={() => setOnOpenBlurState({ ...onOpenBlurState, label: { ...onOpenBlurState.label, [i]: false } })}>
                                                                        <I18AutoCompletion dataTestId="label"
                                                                            value={conditionFields && conditionFields?.label} />
                                                                    </div>
                                                                    :
                                                                    <CustomAutoComplete
                                                                        dataTestId="label"
                                                                        disabled={!props.isCheckedIn}
                                                                        value={conditionFields && conditionFields?.label}
                                                                        onChange={(val) => {
                                                                            console.log({ val })
                                                                            ConditionsChanges({ type: "label", value: val, idx: i })
                                                                        }}
                                                                        onSelect={(val) => {
                                                                            ConditionsChanges({ type: "label", value: val, idx: i })
                                                                        }}
                                                                        onBlur={() => setOnOpenBlurState({ ...onOpenBlurState, label: { ...onOpenBlurState.label, [i]: true } })}
                                                                    />
                                                                }
                                                            </div>
                                                            <div className="panel-div">
                                                                <div style={{
                                                                    width: "60px", display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                    fontSize: "11px", color: "#111827"
                                                                }} >{"Padding"}</div>
                                                                <input className="panel-input" placeholder="eg: 5"
                                                                    onChange={(event: any) => ConditionsChanges({ type: "padding", value: event.target.value, idx: i })}
                                                                    value={conditionFields && conditionFields?.padding}
                                                                ></input>
                                                            </div>
                                                           <div style={{margin:"10px 0px"}}><hr></hr></div>
                                                            <div className="panel-div">
                                                                <div className="panel-label">{"Badge"}</div>
                                                            </div>
                                                            <div className="panel-div">
                                                                <div style={{
                                                                    width: "60px", display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                    fontSize: "11px", color: "#111827"
                                                                }} >{"Icon"}</div>
                                                                <input className="panel-input" placeholder="Enter the icon url"
                                                                    onChange={(event: any) => ConditionsChanges({ type: "badge", value: event.target.value, idx: i,  field: "icon" })}
                                                                    value={conditionFields && conditionFields?.badge?.icon}
                                                                ></input>
                                                            </div>
                                                            <div className="panel-div">
                                                                <div style={{
                                                                    width: "60px", display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                    fontSize: "11px", color: "#111827"
                                                                }} >{"Text"}</div>
                                                                 {onOpenBlurState && onOpenBlurState.badge[i] ?
                                                                    <div onClick={() => setOnOpenBlurState({ ...onOpenBlurState, badge: { ...onOpenBlurState.badge, [i]: false } })}>
                                                                        <I18AutoCompletion dataTestId="label"
                                                                            value={conditionFields && conditionFields?.badge?.text} />
                                                                    </div>
                                                                    :
                                                                    <CustomAutoComplete
                                                                        dataTestId="label"
                                                                        disabled={!props.isCheckedIn}
                                                                        value={conditionFields && conditionFields?.badge?.text}
                                                                        onChange={(val) => {
                                                                            console.log({ val })
                                                                            ConditionsChanges({ type: "badge", value: val, idx: i, field: "text" })
                                                                        }}
                                                                        onSelect={(val) => {
                                                                            ConditionsChanges({ type: "badge", value: val, idx: i , field: "text"})
                                                                        }}
                                                                        onBlur={() => setOnOpenBlurState({ ...onOpenBlurState, badge: { ...onOpenBlurState.badge, [i]: true } })}
                                                                    />
                                                                }
                                                              
                                                            </div>
                                                             <div className="panel-div">
                                                                <div style={{
                                                                    width: "60px", display: "flex",
                                                                    alignItems: "center",
                                                                    fontSize: "11px", color: "#111827"
                                                                }} >{"Font size"}</div>
                                                                <input className="panel-input" placeholder="eg: 5"
                                                                    onChange={(event: any) => ConditionsChanges({ type: "badge", value: event.target.value, idx: i, field: "fontSize" })}
                                                                    value={conditionFields && conditionFields?.badge?.fontSize}
                                                                ></input>
                                                            </div>
                                                            <div className="panel-div">
                                                                <div className="panel-label">{"Font weight"}</div>
                                                                <input className="panel-input" placeholder="eg: 500"
                                                                    onChange={(event: any) => ConditionsChanges({ type: "badge", value: event.target.value, idx: i, field: "fontWeight" })}
                                                                    value={conditionFields && conditionFields?.badge?.fontWeight}
                                                                ></input>
                                                            </div>
                                                            <ColorPicker pickerkey="fontcolor" label="Font color" value={conditionFields?.badge?.fontColor || "#121212"} open={() => dispatch(onsetClrPicContext({
                                                                type: "addExtension_TimeLine",
                                                                value: conditionFields?.badge?.fontColor || "#121212",
                                                                where: 'badgeFontColor',
                                                                idx: i,
                                                                visibility: true
                                                            }))} close={() => dispatch(onsetClrPicContext({ ...colorPickerContext, visibility: false }))}
                                                                visibility={colorPickerContext?.visibility} />
                                                           <div style={{margin:"10px 0px"}}><hr></hr></div>
                                                            <div className="panel-div">
                                                                <div style={{
                                                                    width: "60px", display: "flex",
                                                                    alignItems: "center",
                                                                    fontSize: "11px", color: "#111827"
                                                                }} >{"Title"}</div>

                                                                {onOpenBlurState && onOpenBlurState.title[i] ?
                                                                    <div onClick={() => setOnOpenBlurState({ ...onOpenBlurState, title: { ...onOpenBlurState.title, [i]: false } })}>
                                                                        <I18AutoCompletion dataTestId="label"
                                                                            value={conditionFields && conditionFields?.title?.text} />
                                                                    </div>
                                                                    :
                                                                    <CustomAutoComplete
                                                                        dataTestId="label"
                                                                        disabled={!props.isCheckedIn}
                                                                        value={conditionFields && conditionFields?.title?.text}
                                                                        onChange={(val) => {
                                                                            ConditionsChanges({ type: "title", value: val, idx: i, field: "text" })
                                                                        }}
                                                                        onSelect={(val) => {
                                                                            ConditionsChanges({ type: "title", value: val, idx: i , field: "text"})
                                                                        }}
                                                                        onBlur={() => setOnOpenBlurState({ ...onOpenBlurState, title: { ...onOpenBlurState.title, [i]: true } })}
                                                                    />
                                                                }
                                                              
                                                            </div>
                                                            {/* title color works in status based */}
                                                            {/* <div className="panel-div">
                                                                <div style={{
                                                                    width: "60px", display: "flex",
                                                                    alignItems: "center",
                                                                    fontSize: "11px", color: "#111827"
                                                                }} >{"Font size"}</div>
                                                                <input className="panel-input" placeholder="eg: 5"
                                                                    onChange={(event: any) => ConditionsChanges({ type: "title", value: event.target.value, idx: i, field: "fontSize" })}
                                                                    value={conditionFields && conditionFields?.title?.fontSize}
                                                                ></input>
                                                            </div>
                                                            <div className="panel-div">
                                                                <div className="panel-label">{"Font weight"}</div>
                                                                <input className="panel-input" placeholder="eg: 500"
                                                                    onChange={(event: any) => ConditionsChanges({ type: "title", value: event.target.value, idx: i, field: "fontWeight" })}
                                                                    value={conditionFields && conditionFields?.title?.fontWeight}
                                                                ></input>
                                                            </div>
                                                            <ColorPicker pickerkey="fontcolor" label="Font color" value={conditionFields?.title?.fontColor || "#121212"} open={() => dispatch(onsetClrPicContext({
                                                                type: "addExtension_TimeLine",
                                                                value: conditionFields?.title?.fontColor || "#121212",
                                                                where: 'titleFontColor',
                                                                idx: i,
                                                                visibility: true
                                                            }))} close={() => dispatch(onsetClrPicContext({ ...colorPickerContext, visibility: false }))}
                                                                visibility={colorPickerContext?.visibility} /> */}
                                                            <div className="panel-div">
                                                                <div style={{
                                                                    width: "60px", display: "flex",
                                                                    alignItems: "center",
                                                                    fontSize: "11px", color: "#111827"
                                                                }} >{"Sub-title"}</div>
                                                               {onOpenBlurState && onOpenBlurState.subTitle[i] ?
                                                                    <div onClick={() => setOnOpenBlurState({ ...onOpenBlurState, subTitle: { ...onOpenBlurState.subTitle, [i]: false } })}>
                                                                        <I18AutoCompletion dataTestId="label"
                                                                            value={conditionFields && conditionFields?.subTitle?.text} />
                                                                    </div>
                                                                    :
                                                                    <CustomAutoComplete
                                                                        dataTestId="label"
                                                                        disabled={!props.isCheckedIn}
                                                                        value={conditionFields && conditionFields?.subTitle?.text}
                                                                        onChange={(val) => {
                                                                            console.log({ val })
                                                                            ConditionsChanges({ type: "subTitle", value: val, idx: i, field: "text" })
                                                                        }}
                                                                        onSelect={(val) => {
                                                                            ConditionsChanges({ type: "subTitle", value: val, idx: i , field: "text"})
                                                                        }}
                                                                        onBlur={() => setOnOpenBlurState({ ...onOpenBlurState, subTitle: { ...onOpenBlurState.subTitle, [i]: true } })}
                                                                    />
                                                                }
                                                            </div>
                                                            <div className="panel-div">
                                                                <div style={{
                                                                    width: "60px", display: "flex",
                                                                    alignItems: "center",
                                                                    fontSize: "11px", color: "#111827"
                                                                }} >{"Font size"}</div>
                                                                <input className="panel-input" placeholder="eg: 5"
                                                                    onChange={(event: any) => ConditionsChanges({ type: "subTitle", value: event.target.value, idx: i, field: "fontSize" })}
                                                                    value={conditionFields && conditionFields?.subTitle?.fontSize}
                                                                ></input>
                                                            </div>
                                                            <div className="panel-div">
                                                                <div style={{
                                                                    width: "70px", display: "flex",
                                                                    alignItems: "center",
                                                                    fontSize: "11px", color: "#111827"
                                                                }} >{"Font weight"}</div>
                                                                <input className="panel-input" placeholder="eg: 500"
                                                                    onChange={(event: any) => ConditionsChanges({ type: "subTitle", value: event.target.value, idx: i, field: "fontWeight" })}
                                                                    value={conditionFields && conditionFields?.subTitle?.fontWeight}
                                                                ></input>
                                                            </div>
                                                            <ColorPicker pickerkey="fontcolor" label="Font color" value={conditionFields?.subTitle?.fontColor || "#121212"} open={() => dispatch(onsetClrPicContext({
                                                                type: "addExtension_TimeLine",
                                                                value: conditionFields?.subTitle?.fontColor || "#121212",
                                                                where: 'subTitleFontColor',
                                                                idx: i,
                                                                visibility: true
                                                            }))} close={() => dispatch(onsetClrPicContext({ ...colorPickerContext, visibility: false }))}
                                                                visibility={colorPickerContext?.visibility} />
                                                            <Wrapper>
                                                                <p
                                                                    style={{ color: "#111827", fontSize: 11 }}
                                                                    className="block font-semibold py-1"
                                                                >
                                                                    {"Description"}
                                                                </p>
                                                                <p
                                                                    className="col-span-2 font-medium rounded-md cursor-pointer "
                                                                    style={{
                                                                        color: "#0466C8",
                                                                        backgroundColor: "rgba(4, 102, 200, 0.1)",
                                                                        height: "28px",
                                                                        width: "170px",
                                                                        padding: "5px"
                                                                    }}
                                                                    onClick={() => { setVisibility(true); setEditDescription(true); setDiscription({ id: i, val: conditionFields?.desc }) }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            justifyContent: "center",
                                                                            alignItems: "center"
                                                                        }}
                                                                    >
                                                                        {"Edit description"}
                                                                        {/* <img src={EditorIcon} alt="editorIcon" /> */}
                                                                    </div>
                                                                </p>
                                                            </Wrapper>
                                                            <div className="panel-div">
                                                                <div style={{
                                                                    width: "60px", display: "flex",
                                                                    alignItems: "center",
                                                                    fontSize: "11px", color: "#111827"
                                                                }} >{"Font size"}</div>
                                                                <input className="panel-input" placeholder="eg: 5"
                                                                    onChange={(event: any) => ConditionsChanges({ type: "descFontSize", value: event.target.value, idx: i })}
                                                                    value={conditionFields && conditionFields?.descFontSize}
                                                                ></input>
                                                            </div>
                                                            <ColorPicker pickerkey="fontcolor" label="Font color" value={conditionFields?.descFontColor || "#121212"} open={() => dispatch(onsetClrPicContext({
                                                                type: "addExtension_TimeLine",
                                                                value: conditionFields?.descFontColor || "#121212",
                                                                where: 'descFontColor',
                                                                idx: i,
                                                                visibility: true
                                                            }))} close={() => dispatch(onsetClrPicContext({ ...colorPickerContext, visibility: false }))}
                                                                visibility={colorPickerContext?.visibility} />
                                                            <div className="panel-div">
                                                                <div style={{
                                                                    width: "60px", display: "flex",
                                                                    alignItems: "center",
                                                                    fontSize: "11px", color: "#111827"
                                                                }} >{"Icon"}</div>
                                                                <input className="panel-input" placeholder="eg: https://img.com/ico.p..."
                                                                    onChange={(event: any) => ConditionsChanges({ type: "icon", value: event.target.value, idx: i })}
                                                                    value={conditionFields && conditionFields?.icon}
                                                                ></input>
                                                            </div>
                                                            <Wrapper>
                                                                <p
                                                                    style={{ color: "#111827", fontSize: 11 }}
                                                                    className="block font-semibold py-1"
                                                                >
                                                                    {"On click"}
                                                                </p>
                                                                <p
                                                                    className="col-span-2 font-medium rounded-md cursor-pointer "
                                                                    style={{
                                                                        color: "#0466C8",
                                                                        backgroundColor: "rgba(4, 102, 200, 0.1)",
                                                                        height: "28px",
                                                                        width: "170px",
                                                                        padding: "5px"
                                                                    }}
                                                                    onClick={async () => {
                                                                        // setColorPickerVisibility(false);
                                                                        await openCodeEditorModal();
                                                                        setEditorContext({
                                                                            visibility: true,
                                                                            type: "edit",
                                                                            id: i,
                                                                            source: conditionFields?.onClick || defaultEditorValue,
                                                                            where: "onClick",
                                                                        });
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            justifyContent: "space-between",
                                                                            alignItems: "center",
                                                                        }}
                                                                    >
                                                                        {"On click"}
                                                                        <img src={EditorIcon} alt="editorIcon" />
                                                                    </div>
                                                                </p>
                                                            </Wrapper>
                                                        </div>
                                                    </Disclosure.Panel>
                                                </div>
                                            </Transition>
                                        </>
                                    )}
                                </Disclosure>
                            </div>
                        )
                    })
                }
            </div>
             {visibility &&
                <TextArea
                label={"Description"}
                idx={editDescription ? "edit" : null}
                ConditionsChanges={ConditionsChanges}
                visibility={visibility}
                setVisibility={setVisibility}
                setValue={setConditionFields}
                    value={editDescription ? description : conditionFields}
                />}
            {editorContext.visibility ? (
                <EditorPanel
                    type={"timeline"}
                    ConditionsChanges={ConditionsChanges}
                    setValue={setConditionFields}
                    customdef={functionsdef}
                    isCheckedIn={props.isCheckedIn}
                    close={() => setEditorVisibility(false)}
                    editorContext={editorContext}
                />
            ) : null}
        </div>
    )
}


 